import React from 'react'
import { DatePicker } from 'rsuite';
import { diffrenceBetweenTwoDates, getDiffrenceInDays } from "../../../utils/commonfunction";
import moment from 'moment';

const CustomDateTimePicker = (props) => {
  function handleChange(datetime) {
    props.setField(props.fieldname, datetime);

    if (props?.correspondingEndDate) {
      const totalDays = diffrenceBetweenTwoDates(
        datetime,
        props.correspondingEndDate,
      );
      if (totalDays <= 0) {
        props.formikRef?.current?.setFieldValue(props.correspondingEndDateName, null);
      }
    }

    setTimeout(() => {
      if (
        props?.formikRef?.current?.values?.hotelStartDate &&
        props?.formikRef?.current?.values.hotelEndDate
      ) {
        const totalDays = getDiffrenceInDays(
          props?.formikRef?.current?.values?.hotelStartDate,
          props?.formikRef?.current?.values.hotelEndDate
        );

        const addedDays = totalDays + 1;
        if (addedDays > 0) {
          let newDates = [];

          newDates.push({
            id: 0,
            totalQuantitySingleRoom: "",
            priceSingleRoom: "",
            breakfastPriceSingleRoom: "",
            totalQuantityDoubleRoom: "",
            priceDoubleRoom: "",
            breakfastPriceDoubleRoom: "",
            date: props?.formikRef?.current?.values?.hotelStartDate.toISOString().split("T")[0],
            checkforSingleRoom: true,
            checkforDoubleRoom: true
          });

          let date1 = new Date(props?.formikRef?.current?.values?.hotelStartDate);
          for (let i = 1; i < addedDays; i++) {
            const tomorrow = new Date(date1);
            tomorrow.setDate(date1.getDate() + 1);
            newDates.push({
              id: i,
              totalQuantitySingleRoom: "",
              priceSingleRoom: "",
              breakfastPriceSingleRoom: "",
              totalQuantityDoubleRoom: "",
              priceDoubleRoom: "",
              breakfastPriceDoubleRoom: "",
              date: tomorrow.toISOString().split("T")[0],
              checkforSingleRoom: true,
              checkforDoubleRoom: true
            });
            date1 = tomorrow;
          }

          props.formikRef?.current?.setFieldValue("hotelTotalDays", newDates);
        }
      }
    }, 500);
  }

  const handleBlur = () => {
    props.setFieldTouched(props.fieldname, true);
  };

  return (
    <div className='row col-md6'>
      <DatePicker
        key={
          props?.calendarDefaultDate
            ? new Date(props.calendarDefaultDate).toISOString()
            : "default-calendar-date"
        }
        disabled={props.disabled ? props.disabled : false}
        className='col-md6'
        oneTap={true}
        placeholder={props.placeholder ? props.placeholder : "Select date"}
        onChange={handleChange}
        onBlur={handleBlur}
        value={props.value ? props.value : null}
        cleanable={true}
        editable={false}
        calendarDefaultDate={
          props?.calendarDefaultDate
            ? new Date(props.calendarDefaultDate)
            : undefined
        }
      />
    </div>
  );
}

export default CustomDateTimePicker;
